import { createSelector } from "reselect";
import moment from "moment";
import sortedUniqBy from "lodash.sorteduniqby";

// Selectors
import {
  createStudyForPatientIdSelector,
  assessmentAnswersResourceSelectors
} from "src/selectors/data_selectors";

/**
 * Create a selector for assessment answers with an assessmentId sorted by createdAt, uniqe on assessmentAnswerGroup, excluding striken assessments
 * @param {string} assessmentId
 * @returns {array}
 */
export function createSortedAssessmentAnswersForAssessmentIdAndPatientIdSelector(
  assessmentId,
  patientId
) {
  return createSelector(
    createStudyForPatientIdSelector(patientId),
    assessmentAnswersResourceSelectors.dataSelector,
    (study, assessmentAnswers) => {
      if (!study) {
        return [];
      }
      let filteredAssessmentAnswers = Object.values(assessmentAnswers)
        .filter(aa => {
          return (
            aa.attributes.resourceId == study.id &&
            aa.attributes.resourceType == "Study" &&
            aa.attributes.assessmentId == assessmentId &&
            aa.attributes.completed
          );
        })
        .sort((a1, a2) => {
          return moment(a1.attributes.createdAt).isAfter(
            a2.attributes.createdAt
          )
            ? -1
            : 1;
        });

      const struckOutGroupIds = filteredAssessmentAnswers.reduce((agg, aa) => {
        if (aa.attributes.strikeoutState == "stricken") {
          agg.push(aa.attributes.assessmentAnswerGroupId);
        }
        return agg;
      }, []);

      filteredAssessmentAnswers = filteredAssessmentAnswers.filter(aa => {
        return !struckOutGroupIds.includes(
          aa.attributes.assessmentAnswerGroupId
        );
      });

      return sortedUniqBy(
        filteredAssessmentAnswers,
        aa => aa.attributes.assessmentAnswerGroupId
      );
    }
  );
}
